var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: { width: "900", "mask-closable": false },
          model: {
            value: _vm.isShow,
            callback: function($$v) {
              _vm.isShow = $$v
            },
            expression: "isShow"
          }
        },
        [
          _vm.agreementType === "VAT"
            ? _c("div", { staticClass: "content" }, [
                _c("div", { staticClass: "header" }, [
                  _vm._v("税智汇用户协议-VAT：")
                ]),
                _vm._v("\n      欢迎您使用税智汇网络科技有限公司平台服务！"),
                _c("br"),
                _vm._v(
                  "\n      本服务协议是您（或称“用户”）与税智汇之间（“税智汇”是指深圳市税智汇网络科技有限公司和/或其相关服务可能存在的运营关联单位），就为您本人及/或您所代表或代理的第三方，通过使用税智汇VAT税务服务平台（以下简称“平台”）提供的税智汇VAT税务服务（以下简称“本服务”），进行VAT税务服务相关事宜所订立的有效合约。"
                ),
                _c("br"),
                _vm._v(
                  "\n      在使用平台服务之前，请您务必审慎阅读、充分理解本协议(如果您未满16周岁，或已满16周岁未满18周岁且不能以自己的劳动收入作为主要收入来源的，请在法定监护人的陪同下阅读本协议）各项条款，特别是限制或免除责任条款、隐私保护政策、帐号规则、法律适用和争议解决条款（包括管辖条款），以及其它以加粗加黑和/或加下划线等显示形式提示您注意的重要条款，请务必重点查阅。"
                ),
                _c("br"),
                _vm._v(
                  "\n      若您不同意本协议，则您有充分且完全的权利退出使用平台服务（但这并不妨碍您浏览平台中的商品信息），您通过网络页面点击注册和/或实际使用平台服务的行为即视为您已阅读、理解并同意接受本协议。如果您对本协议有任何的疑问、投诉、意见和建议，欢迎您通过本协议所附联系方式与我们沟通反馈，我们十分乐意为您解答。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("第1条 基础约定")]),
                _vm._v(
                  "\n      1.1\n      协议范围：考虑到互联网服务以及产品频繁迭代更新等行业特点，为了更全面的界定您与平台之间的权利义务，本协议包括我们根据法律法规规定以及本协议制定的其他政策、规则、公告声明等（除非特有所指，合称为“本协议”），您也应当加以遵守。"
                ),
                _c("br"),
                _vm._v(
                  "\n      1.2\n      服务范围：我们可能通过不断丰富的功能界面向您提供本协议项下的平台服务，包括但不限于移动应用程序（“微信公众号”）、PC端网站、微信小程序、“[VAT]”系统软件服务以及其他形式。具体以我们实时发布的服务功能界面范围为准。"
                ),
                _c("br"),
                _vm._v(
                  "\n      1.3\n      修改与更新：我们有权遵照法律法规规定，在必要时修改本协议（包括适时制定并发布其他政策、规则、公告声明），更新后的协议条款将代替原来的协议并在法律规定的期限届满后正式生效，您可以在相关服务页面查阅最新版本的协议条款。本协议修改后，如果您继续使用平台服务的，即视为您已接受修改后的协议。如果您不接受修改后的协议，则您有权利停止使用平台服务。"
                ),
                _c("br"),
                _vm._v(
                  "\n      1.4\n      平台授予用户一项个人的、不可转让及使用（除本协议另有声明外）的许可，以供您使用平台服务，用户可以以非商业目的使用。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("第2条 平台服务内容")]),
                _vm._v(
                  "\n      2.1\n      平台为您提供英国、德国等（目的国）增值税VAT自主注册和申报服务，您需要在VAT服务目的国的时效要求前，按照平台要求注册、填写信息、上传资料，平台将把您提交的信息接入到目的国税务系统完成VAT服务。"
                ),
                _c("br"),
                _vm._v(
                  "\n      2.2\n      平台为您提供丰富的服务，分为免费服务和收费服务。对于现阶段免费提供的服务内容，平台有权根据平台政策的调整将其变更为收费服务，如果发生该变更事项时，平台将通过网页提示、信息通知等方式提前告知您，如果您不同意的，可以停止使用该服务。对于收费的服务内容，平台有权自行确定该等服务的价格并不时调整，调整后的价格将在平台中进行公示，如果您不同意调整后的价格的，则您可以在其原购买的收费服务到期后停止付费购买收费服务。如果您在平台调整价格并公示后，仍继续购买收费服务的，则视为您同意该调整后的价格。"
                ),
                _c("br"),
                _vm._v(
                  "\n      2.3\n      平台建立便捷有效的投诉机制并将尽最大努力及时受理并处理您的投诉，同时，当您与平台出现争议时，若您同意平台争议解决规则，则我们亦将协助您处理您的争议。您同意平台根据平台所了解到的争议事实并依据平台争议解决规则，以普通人的注意义务程度，独立的作出调处决定。如您对调处决定不满意，您仍有权采取其他法定争议处理途径解决争议，但通过其他争议处理途径未取得终局决定前，您同意先履行调处决定。"
                ),
                _c("br"),
                _vm._v(
                  "\n      2.4\n      为了更好的完成服务以及提升用户体验等目的，平台亦将为您提供更为友好完善的平台服务，并优化和引入第三方服务。由此发生的法律关系是由您和该等第三方服务商之间形成，和平台无关。"
                ),
                _c("br"),
                _vm._v(
                  "\n      2.5\n      您同意并知悉，平台中的具体内容、功能和形式由平台根据实际情况按实际可见的状态提供，我们有权自行确定平台服务的具体内容、功能和形式（例如，我们可能仅在特定的国家或地区以特定的语言提供），有权自行决定增加、变更、中断和停止平台具体的内容、功能和形式。具体以平台实时呈现的服务内容、功能和形式为准。为保证您能正常享受平台提供给您的服务，您在接受平台给您提供的具体服务过程中应遵守的细则，应以平台通知的为准。"
                ),
                _c("br"),
                _vm._v(
                  "\n      2.6您同意并知悉，您购买的服务内容包含了税智汇为您提供的VAT系统软件服务。如您购买税智汇VAT注册服务的，税智汇提供的服务时间为税号生效日期起满一年；您购买税智汇VAT续费服务的，服务时间以自税号在税智汇系统到期之日起一年；您购买税智汇VAT转代理服务的，服务时间为转代理成功之日在税智汇系统第一次申报起一年。您的VAT服务期限与税智汇为您提供的“[VAT]”系统软件服务期限保持一致。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("第3条 用户使用规范")]),
                _vm._v(
                  "\n      3.1\n      您应当在有效的时间节点前在平台系统中提交完成VAT服务所需的全部资料（包括但不限于您在亚马逊等电商平台上的原始销售数据）。若您未按照平台要求提交资料，经平台短信&微信推送提示后仍未提交，由此造成的损失由您自行承担。如目的国政策调整，平台将以短信&微信推送消息的方式通知您调整提供资料的时间，请予以配合。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.2\n      您在使用本平台的期间内，您有任何法律及工商变更，包括但不限于法定代表人变更、公司地址变更、联系人变更等情形出现时，应当在变更后1个工作日内完成本平台系统内的信息更改，或者通知和联系平台客服进行更改；若您未按照要求更改信息造成的全部损失由您自行承担。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.3为确保您能及时注册或者申报VAT服务，请留意VAT目的国的时效政策，例如在英国季度申报截至日期前10个工作日在平台系统提供并填写所需的资料，在德国申报当月的4日前在平台系统提供并填写所需的资料。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.4\n      您必须及时在平台提交办理VAT服务有关的资料，并对其真实性、完整性、合法性负责。平台不负责对您文件和资料的真实性进行审核。如果因为您提供的资料出现任何问题导致的法律责任，由您承担；若因此导致VAT服务无法实现的，平台亦不承担责任；若因此造成平台损失的，您还须赔偿平台的一切损失。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.5\n      您应当在英国税务申报月份的次月2日之前一次性将当月所需要依法缴纳的税金安排支付至英国税务局；在德国税务申报当月的10日之前一次性将当月所需要依法缴纳的税金安排支付至德国税务局；因逾期支付或者不支付税金而造成的滞纳金、罚金由您自行承担；如因此造成平台损失的，您还需赔偿平台的一切损失。如因您的原因不进行税务申报、不支付税金累计达到两次时，平台有权停止您的服务，您在平台内的费用将按照实际使用的服务进行扣除，多余部分平台将予以退还，不足部分您应该向平台进行补足，平台不因此承担任何违约责任。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.6\n      您在使用本平台的期间内，如遇到目的国增值税（VAT）税收调查，您应当积极配合目的国税务局在规定时间内提供销售发票及数据；因您提供的数据申报错误等原因产生的罚金或滞纳金，您应当在目的国税局规定的时间内补交。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.7\n      您作为平台使用者以及增值税VAT的所有者，有义务对增值税的债权债务负责，平台作为软件服务提供方不对您的增值税负责。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.8\n      如果您在付费时使用了优惠券或折扣等其他优惠方式的，则您在按照本款约定申请退款时，您无权就该优惠券或折扣申请退款或补偿。平台有权保留已终止服务用户的所有使用信息，对您在使用付费服务期间发生的违反本协议及相关规定的行为，平台仍有权行使本协议规定的权利并追究用户的法律责任。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.9\n      当您所购买的“[VAT]”系统软件服务到期时，您应及时向税智汇续费，否则，税智汇有权停止提供服务。如因您没有及时续费而造成“[VAT]”系统软件停止服务，税智汇不承担责任。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.10 您应及时在“[VAT]”系统提交办理VAT服务有关的资料，并对其真实性、完整性、合法性负责。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.11\n      您应及时在“[VAT]”系统提交税务申报及缴纳税金，如因您逾期申报，逾期缴纳税金等所导致的任何罚金、店铺冻结等情况，您自行承担责任。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.12 您选择购买税智汇VAT服务，须知晓并认可税智汇关于此服务的以下要求："
                ),
                _c("br"),
                _vm._v(
                  "\n      1）及时申报: 如逾期未申报(含未支付税金等未完成申报)，需要缴纳补申报费用才可以重新申报"
                ),
                _c("br"),
                _vm._v(
                  "\n      2）申报区间齐全: 必须保证所有申报区间均有申报，不能出现某一月、季无申报记录"
                ),
                _c("br"),
                _vm._v(
                  "\n      3）及时续费: 到期当月未续费，次月停止申报及税号移除"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.13\n      税智汇有权对“[VAT]”系统上您发布、推广的内容进行监督，如有涉及违反法律、法规或任何第三方合法权利的内容、文字、链接等，税智汇有权立刻删除。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.14\n      如您未在服务到期的最后一天前进行续费，税智汇有权对您的税号进行移除代理操作，由此可能产生的税号失效、罚金等风险，税智汇不对此承担责任，由您自行承担。若您需要转代理，需要提前两个月告知税智汇并及时进行转代理操作，若您未在服务到期前准确告知税智汇即转出，税智汇有权对您的税号全权处理，由此产生的后果税智汇不对此进行负责"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("第4条 用户帐号规则")]),
                _vm._v(
                  "\n      4.1\n      您在注册或使用平台服务时可能需要提供一些必要的信息。您须保证所填写及所提供的资料真实、准确、完整，否则可能无法使用平台服务，或在使用过程中受到限制，甚至影响您是否能够使用平台特定功能。对于因您提供的信息不真实、不准确或不完整导致的责任和损失由您承担。"
                ),
                _c("br"),
                _vm._v(
                  "\n      4.2\n      平台有权根据您所提供资料的真实性、准确性、完整性以及是否符合平台服务规定的其他条件，决定是否为您提供服务。您在使用平台服务过程中，所提供的信息发生变动，应及时进行变更。"
                ),
                _c("br"),
                _vm._v(
                  "\n      4.3\n      您注册成功后，我们将为您配置帐号，该帐号之所有权归平台所有，用户在本协议有效期内仅享有使用权。未经平台同意，用户的帐号仅供用户本人使用，帐号信息和权限不得以转让、赠与、借用、售卖、授权或租用等方式许可给第三方使用或和第三方共同控制、使用。"
                ),
                _c("br"),
                _vm._v(
                  "\n      4.4如果您需要注销您的帐号，您有权通过平台公布的方式、程序进行，我们将在核实您的身份并清理帐号资产（例如已充值或已获得的虚拟资产等）及纠纷争议后，为您提供帐号注销服务。在注销帐号之后本协议即终止，我们将停止为您提供任何服务。同时对您的平台的所有数据将不做保存。当然，我们也保留权利在您的帐号符合回收的如下情况下，直接回收并注销您的帐号并停止服务：（1）未通过实名认证；（2）其它情况。"
                ),
                _c("br"),
                _vm._v(
                  "\n      4.5\n      用户一经注册，即可能可以在平台及我们关联公司运营的其它产品，或者合作伙伴等第三方平台中通行使用。在使用平台服务帐号登录并使用其他产品或服务时，除遵守本协议约定外，还应遵守该等产品的服务协议的约定。平台服务和其他产品对可能出现的纠纷在法律规定和约定的范围内各自承担责任。"
                ),
                _c("br"),
                _vm._v(
                  "\n      4.6为客户体验及功能服务考虑，您在使用不同服务时被要求填写的信息内容可能不完全一致，因此，为了给您提供更好的服务及为了您的登录帐号安全，可能需要您补充完整信息后方可使用。"
                ),
                _c("br"),
                _vm._v(
                  "\n      4.7您有责任自行负责保管帐号的用户名和密码等信息，否则因该等事项引发的法律责任由用户自行承担。凡使用平台服务登录帐号和登录凭证的行为，平台服务视为您本人的操作，操作所产生的电子信息记录均为平台服务用户行为的有效凭据。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("第5条 用户行为规范")]),
                _vm._v(
                  "\n      5.1 您保证合理地使用平台服务，并接受本协议和我们适时制定并发布的其他政策、规则、公告声明。"
                ),
                _c("br"),
                _vm._v(
                  "\n      5.2 行为禁止：您可在本协议约定的范围内使用平台及服务，您不得利用平台从事以下行为："
                ),
                _c("br"),
                _vm._v("\n      （1）超出授权或恶意使用平台服务；"),
                _c("br"),
                _vm._v(
                  "\n      （2）利用平台发表、传送、传播、储存危害国家安全、国家统一、社会稳定的内容，或侮辱诽谤、色情、暴力、引起他人不安及任何违反国家法律法规政策的内容，或者设置含有上述内容的网名、角色名，发布、传送、传播违法广告信息、营销信息及垃圾信息等；"
                ),
                _c("br"),
                _vm._v(
                  "\n      （3）利用平台侵害他人知识产权、肖像权、隐私权、名誉权、个人信息等合法权利或权益；"
                ),
                _c("br"),
                _vm._v(
                  "\n      （4）恶意虚构或协助虚构事实、评价等信息或数据；"
                ),
                _c("br"),
                _vm._v(
                  "\n      （5）进行任何危害计算机网络安全的行为，包括但不限于：使用未经许可的数据或进入未经许可的服务器/账户；未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；未经许可，企图探查、扫描、测试本“软件”系统或网络的弱点或其它实施破坏网络安全的行为；企图干涉、破坏本“软件”系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；伪造TCP/IP数据包名称或部分名称；利用平台及服务上传任何病毒、木马，或者蠕虫等危害网络健康的内容；"
                ),
                _c("br"),
                _vm._v(
                  "\n      （6）对平台进行反向工程、反向编译或反向汇编或以其它方式企图发现平台的源代码和算法，未经许可修改、禁用软件的任何功能或创建基于软件的衍生作品。去除平台或文档上的任何所有权声明或标签，或将其他软件与平台合并；"
                ),
                _c("br"),
                _vm._v(
                  "\n      （7）进行任何破坏我们提供服务公平性或者其他影响应用正常秩序的行为，如主动或被动刷分、合伙作弊、使用外挂或者其他的作弊软件、利用BUG（又叫“漏洞”或者“缺陷”）来获得不正当的非法利益，或者利用互联网或其他方式将外挂、作弊软件、BUG公之于众；"
                ),
                _c("br"),
                _vm._v(
                  "\n      （8）从事其他法律法规、政策及公序良俗、社会公德禁止的行为以及侵犯其他个人、公司、社会团体、组织的合法权益的行为。"
                ),
                _c("br"),
                _vm._v(
                  "\n      5.3\n      信息内容规范：为了营造良好网络生态，保障公民、法人和其他组织的合法权益，维护国家安全和公共利益，我们将根据《中华人民共和国国家安全法》《中华人民共和国网络安全法》《互联网信息服务管理办法》等法律、行政法规，自觉践行社会主义核心价值观，营造清朗的网络空间，并开展的弘扬正能量、处置违法和不良信息等相关活动。"
                ),
                _c("br"),
                _vm._v("\n      5.4 信息内容的使用规范"),
                _c("br"),
                _vm._v(
                  "\n      5.4.1 未经我们书面许可，您不得自行或授权、允许、协助任何第三人对平台中信息内容进行如下行为："
                ),
                _c("br"),
                _vm._v(
                  "\n      （1）复制、读取、采用平台的信息内容，用于任何形式的商业用途；"
                ),
                _c("br"),
                _vm._v(
                  "\n      （2）擅自编辑、整理、编排平台及相关服务的信息内容后在平台及相关服务的源页面以外的渠道进行展示；"
                ),
                _c("br"),
                _vm._v(
                  "\n      （3）采用不正当方式，自行或协助第三人对平台及相关服务的信息内容产生流量、阅读量或交易引导、转移、劫持等不利影响。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("第6条 个人信息保护与隐私政策")]),
                _vm._v(
                  "\n      6.1\n      尊重用户隐私并保护您的个人信息安全是我们的一贯态度，平台将会采取合理的措施保护您的个人信息与隐私。我们承诺，除非获得用户同意，平台不会收集、使用其提供服务所必需以外的用户个人信息或者将信息用于提供服务之外的目的。但是平台因需要向VAT注册国政府及税局等机关提交资料的情形除外。\n      "
                ),
                _c("br"),
                _vm._v(
                  "\n      6.2 在您使用本平台的过程中，平台将遵循合法、正当、必要的原则，收集您的相关信息，包括但不限于："
                ),
                _c("br"),
                _vm._v(
                  "\n      （1）用户注册或登录的账户信息，例如用户注册账户使用的电话号码、姓名或昵称、公司名等信息；"
                ),
                _c("br"),
                _vm._v(
                  "\n      （2）用户用于办理VAT服务上传的信息，例如用户的营业执照、销售数据等用户主动填写的信息或用户与平台客服联系时提供的相关信息等；"
                ),
                _c("br"),
                _vm._v(
                  "\n      （3）用户使用平台过程中产生的信息。平台会根据用户授予的权限，接收并记录用户所使用的设备相关信息，例如设备属性信息、设备位置信息、设备连接信息等；"
                ),
                _c("br"),
                _vm._v(
                  "\n      （4）平台根据用户授权通过合法方式收集的其他用户信息。 "
                ),
                _c("br"),
                _vm._v(
                  "\n      6.3\n      安全保护：我们将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息及隐私安全，以免遭受未经授权的访问、使用或披露。"
                ),
                _c("br"),
                _vm._v(
                  "\n      6.4\n      信息使用与披露：我们有权在遵守法律法规的前提下，以明示的方式获取、使用、储存和分享您的个人信息。我们不会在未经您授权时，公开、编辑或透露您的个人信息及您保存在我们的非公开内容。您同意并保证：平台有权根据我们制定的个人信息保护规则收集使用您的相关信息。"
                ),
                _c("br"),
                _vm._v(
                  "\n      6.5\n      您同意，我们有权通过cookie等技术收集您的使用、行为信息，并在经过数据脱敏使之不再指向、关联到您个人的身份信息时，自由使用脱敏后的纯商业数据。当然，您也可根据自己的偏好删除Cookie，但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。目前删除Cookie的一般路径是浏览器：“设置-清除数据”，或者将手机系统还原/清除。"
                ),
                _c("br"),
                _vm._v(
                  "\n      6.6\n      在遵守本协议项下特别约定的个人信息保护与隐私政策外，我们希望您认真并完整阅读我们特别针对平台而制定并适时发布的《隐私权政策》，这将更有助于保障您的个人信息。"
                ),
                _c("br"),
                _vm._v("\n      6.7 税智汇以下行为不受此条款的限制："),
                _c("br"),
                _vm._v(
                  "\n      ①因实现本合同目的需要向目的国政府及税局等机关提交相关资料；"
                ),
                _c("br"),
                _vm._v(
                  "\n      ②应政府部门等机构要求或办理业务需要，向政府部门等相关机构提交相关资料；"
                ),
                _c("br"),
                _vm._v(
                  "\n      ③因外部审计等需要而向律师事务所、会计师事务所等中介机构提供相关资料。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("第7条 信息或广告推送")]),
                _vm._v(
                  "\n      7.1\n      您同意在接受我们提供服务的同时，允许我们在遵守法律法规的前提下自行或由第三方广告商向您发送、展示广告、推广或宣传信息（包括商业与非商业信息）。如您对发送、推荐的广告或信息不感兴趣，您可以基于我们提供的相关技术选项，控制系统向您展示或不展示/减少展示相关类型的广告或信息。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("第8条 知识产权等权益")]),
                _vm._v(
                  "\n      8.1\n      我们对平台中所包含的受知识产权或其他法律保护的资料享有相应的权利；除依法由用户享有著作权的内容之外，平台的整体内容的知识产权归我们或关联公司所有。"
                ),
                _c("br"),
                _vm._v(
                  "\n      8.2关于信息内容的投诉或举报。若您在使用平台过程中，不慎受到合法权益的侵犯，您有权通知我们采取必要措施进行处置。若您在使用平台过程中，发现存在违法违规或违反本服务相关规则的情况，您也有权向我们发起举报，我们亦会及时采取必要措施（删除、屏蔽、断开链接或限制使用功能等）进行处置。"
                ),
                _c("br"),
                _vm._v(
                  "\n      8.3内容维权授权。在法律法规允许的范围内，您同意并授权我们就侵犯您合法权益的行为（包括但不限于私自复制、使用、编辑、抄袭等行为）采取任何形式的法律行动，包括但不限于投诉、诉讼等必要的维权措施。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("第9条 免责声明")]),
                _vm._v(
                  "\n      9.1\n      我们对于您自平台而获得的所有他人、第三方的信息、内容或者广告宣传等任何资讯（以下统称“信息”），除法律明确规定外，不保证真实、准确和完整性。如果任何单位或者个人通过上述“信息”而进行任何行为，您须自行甄别真伪和谨慎预防风险。您在接受平台及服务时，有可能会接触到令人不快、不适当或令人厌恶的内容，在任何情况下，我们均不对任何此等内容承担任何责任。无论何种原因，我们不对任何非与我们直接发生的交易或行为承担任何直接、间接、附带或衍生的损失和责任。"
                ),
                _c("br"),
                _vm._v(
                  "\n      9.2\n      鉴于互联网服务的特殊性，您理解并同意我们在以下情况下无需对您所遭受的损失（包括但不限于财产、收益、数据资料等方面的损失或其它无形损失）承担责任："
                ),
                _c("br"),
                _vm._v(
                  "\n      （1）因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素导致平台及服务障碍不能正常运作；"
                ),
                _c("br"),
                _vm._v(
                  "\n      （2）由于计算机病毒、木马、其他恶意程序、黑客攻击、电信部门及网络运营公司技术调整或故障、系统维护等意外原因而造成平台及服务中断或延迟。"
                ),
                _c("br"),
                _vm._v(
                  "\n      9.3\n      平台有权不时对提供的所有服务实施优惠政策或开展优惠活动，该等优惠政策或优惠活动以平台发布的实时信息为准，您知悉并认可，平台有权自行决定是否提供优惠政策或开展优惠互动，以及优惠政策或优惠活动的内容、条件和有效期，并不时进行调整或。对于不同活动期内不同的价格，平台不允诺担保您享有的是最低服务价格。"
                ),
                _c("br"),
                _vm._v(
                  "\n      9.4\n      有限责任：平台在适用法律所允许的最大范围内，不论出于何种原因，平台对您的全部责任为您使用本平台产品和服务而向平台支付的费用总额。如果平台免费向您提供了服务，则平台无义务对您承担任何赔偿责任。任何情况下，平台不对出自本协议或与本协议有关的或与平台的运行有关的任何特殊的、偶然的、惩罚性或间接的损害（包括但不限于数据损失、利润损失或营业损失）或采购替代产品承担责任，不论该等责任是基于合同、担保、侵权（包括过失）、严格责任或其他，也不论平台是否被事先告知了损失或损害发生的可能性。即使本协议约定的有限补救措施未能实现其根本目的，前述的责任限制依然适用。"
                ),
                _c("br"),
                _vm._v(
                  "\n      9.5\n      如果您通过合法方式获得了相关付费服务的优惠券或折扣等其他优惠方式的，则用户知悉并认可，该等优惠券或折扣必须满足一定条件才能使用，以优惠券上的信息提示和优惠券使用说明、或平台公示的折扣使用说明为准。优惠券或折扣不兑现（即不直接兑换现金）、不找零（即订单金额不足抵用券金额的，抵用券剩余金额无效）、过期作废；优惠券或折扣仅限同一用户账号使用，严禁出售、转让或共享，如经平台发现存在出售、转让或共享优惠券或折扣等其他优惠方式的，该优惠券或折扣将予以作废处理，且平台有权视情节严重程度予以封号处理，并保留追究相关责任人法律责任的权利。"
                ),
                _c("br"),
                _vm._v(
                  "\n      9.6 免责：如因下所列任何原因而造成的用户资料泄露、丢失、被盗用或被篡改等，平台均有权获得免责："
                ),
                _c("br"),
                _vm._v(
                  "\n      （1）任何因政府管制而造成的暂时性关闭等影响网络正常浏览的不可抗力原因；"
                ),
                _c("br"),
                _vm._v(
                  "\n      （2）任何计算机系统问题、黑客攻击、计算机病毒侵入或发作的原因；"
                ),
                _c("br"),
                _vm._v(
                  "\n      （3）任何因网络安全问题导致的账户或银行卡信息泄露，该风险可能会给用户造成经济损失，用户承诺自行承担向侵权方追究责任及追究责任不能的后果；"
                ),
                _c("br"),
                _vm._v(
                  "\n      （4）任何因用户个人原因导致的用户资料泄露、丢失、被盗用或被篡改等；"
                ),
                _c("br"),
                _vm._v("\n      （5）其他不能归责于公司的原因。"),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("第10条 违约责任")]),
                _vm._v(
                  "\n      10.1\n      如果我们发现、收到他人举报或投诉您违反本协议约定或违反法律法规和国家有关规定的，我们有权采取警示、冻结、终止/中止/限制使用帐号等功能、解除或终止本协议，或提出损害赔偿等措施。"
                ),
                _c("br"),
                _vm._v(
                  "\n      10.2\n      若您的行为给我们造成损失的（包括但不限于直接损失、名誉损失、第三方的罚款、索赔等），我们有权全额向您追偿，如您在平台中有保证金、虚拟货币等财产或优惠券等虚拟权益的，我们有权冻结。"
                ),
                _c("br"),
                _vm._v(
                  "\n      10.3\n      本协议终止后，除法律有明确规定外，平台无义务向您或您指定的第三方披露您账户中的任何信息。本协议终止后，平台仍享有下列权利：根据法律规定，继续保存您留存于平台的的各类信息；对于您过往的违约行为，平台仍可依据本协议向您追究违约责任。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("第11条 退款规则")]),
                _vm._v(
                  "\n      11.1您知悉并确认仅符合如下条件之一，税智汇才会将您支付的相关服务费全部或部分退还给您："
                ),
                _c("br"),
                _vm._v(
                  "\n      ①\n      由于市场变化及各种因素的影响，税智汇无法保证您提交的申请委托服务都能提供，如您拟购买的服务发生“暂时无法提供服务”的情况，您和税智汇均有权取消订单，并全额退还已支付的案件相关费用。"
                ),
                _c("br"),
                _vm._v(
                  "\n      ②您成功购买服务后，如您在向提交资料前向税智汇提出终止或解除本合同的，税智汇有权要求您承担服务费总额20%的违约金，如您已支付部分/全部服务费，税智汇有权直接从您已支付费用中进行扣除；如您在向税智汇提交材料后提出终止或解除本合同的，税智汇有权要求您全额支付本协议项下的服务费，且不予退还您已付费用。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("第12条 法律适用与管辖")]),
                _vm._v(
                  "\n      12.1 本协议的订立、执行、解释及争议的解决均适用中华人民共和国法律。"
                ),
                _c("br"),
                _vm._v(
                  "\n      12.2\n      如双方就平台服务协议内容或其履行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向税智汇所在地人民法院提起诉讼。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("第13条 如何联系我们")]),
                _vm._v(
                  "\n      如果您有任何的疑问、投诉、意见和建议，欢迎您与我们沟通反馈。我们的联系方式见下："
                ),
                _c("br"),
                _vm._v("\n      联系电话：4001828088"),
                _c("br")
              ])
            : _vm.agreementType === "compliance"
            ? _c("div", { staticClass: "content" }, [
                _c("div", { staticClass: "header" }, [
                  _vm._v("税智汇用户协议-合规认证：")
                ]),
                _vm._v("\n      欢迎您使用税智汇网络科技有限公司平台服务！"),
                _c("br"),
                _vm._v(
                  "\n      本服务协议是您（或称“用户”）与税智汇之间（“税智汇”是指深圳市税智汇网络科技有限公司和/或其相关服务可能存在的运营关联单位），就为您本人及/或您所代表或代理的第三方，通过使用税智汇VAT税务服务平台（以下简称“平台”）提供的税智汇产品合规认证服务（以下简称“本服务”），进行产品合规认证相关事宜所订立的有效合约。"
                ),
                _c("br"),
                _vm._v(
                  "\n      在使用平台服务之前，请您务必审慎阅读、充分理解本协议(如果您未满16周岁，或已满16周岁未满18周岁且不能以自己的劳动收入作为主要收入来源的，请在法定监护人的陪同下阅读本协议）各项条款，特别是限制或免除责任条款、隐私保护政策、帐号规则、法律适用和争议解决条款（包括管辖条款），以及其它以加粗加黑和/或加下划线等显示形式提示您注意的重要条款，请务必重点查阅。"
                ),
                _c("br"),
                _vm._v(
                  "\n      若您不同意本协议，则您有充分且完全的权利退出使用平台服务（但这并不妨碍您浏览平台中的商品信息），您通过网络页面点击注册和/或实际使用平台服务的行为即视为您已阅读、理解并同意接受本协议。如果您对本协议有任何的疑问、投诉、意见和建议，欢迎您通过本协议所附联系方式与我们沟通反馈，我们十分乐意为您解答。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("第1条 基础约定")]),
                _vm._v(
                  "\n      1.1\n      协议范围：考虑到互联网服务以及产品频繁迭代更新等行业特点，为了更全面的界定您与平台之间的权利义务，本协议包括我们根据法律法规规定以及本协议制定的其他政策、规则、公告声明等（除非特有所指，合称为“本协议”），您也应当加以遵守。"
                ),
                _c("br"),
                _vm._v(
                  "\n      1.2\n      服务范围：我们可能通过不断丰富的功能界面向您提供本协议项下的平台服务，包括但不限于移动应用程序（“微信公众号”）、PC端网站、微信小程序、“[合规认证]”系统软件服务以及其他形式。具体以我们实时发布的服务功能界面范围为准。"
                ),
                _c("br"),
                _vm._v(
                  "\n      1.3\n      修改与更新：我们有权遵照法律法规规定，在必要时修改本协议（包括适时制定并发布其他政策、规则、公告声明），更新后的协议条款将代替原来的协议并在法律规定的期限届满后正式生效，您可以在相关服务页面查阅最新版本的协议条款。本协议修改后，如果您继续使用平台服务的，即视为您已接受修改后的协议。如果您不接受修改后的协议，则您有权利停止使用平台服务。"
                ),
                _c("br"),
                _vm._v(
                  "\n      1.4\n      平台授予用户一项个人的、不可转让及使用（除本协议另有声明外）的许可，以供您使用平台服务，用户可以以非商业目的使用。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("第2条 平台服务内容")]),
                _vm._v(
                  "\n      2.1\n      平台为您提供平台界面展示的各国产品合规（授权代表、EPR、能效标签）认证注册申报服务，您需要在合规认证服务目的国的时效要求前，按照平台要求注册、填写信息、上传资料，平台将把您提交的信息接入到目的国官方系统完成合规认证服务。"
                ),
                _c("br"),
                _vm._v(
                  "\n      2.2\n      平台为您提供丰富的服务，分为免费服务和收费服务。对于现阶段免费提供的服务内容，平台有权根据平台政策的调整将其变更为收费服务，如果发生该变更事项时，平台将通过网页提示、信息通知等方式提前告知您，如果您不同意的，可以停止使用该服务。对于收费的服务内容，平台有权自行确定该等服务的价格并不时调整，调整后的价格将在平台中进行公示，如果您不同意调整后的价格的，则您可以在其原购买的收费服务到期后停止付费购买收费服务。如果您在平台调整价格并公示后，仍继续购买收费服务的，则视为您同意该调整后的价格。"
                ),
                _c("br"),
                _vm._v(
                  "\n      2.3\n      平台建立便捷有效的投诉机制并将尽最大努力及时受理并处理您的投诉，同时，当您与平台出现争议时，若您同意平台争议解决规则，则我们亦将协助您处理您的争议。您同意平台根据平台所了解到的争议事实并依据平台争议解决规则，以普通人的注意义务程度，独立的作出调处决定。如您对调处决定不满意，您仍有权采取其他法定争议处理途径解决争议，但通过其他争议处理途径未取得终局决定前，您同意先履行调处决定。"
                ),
                _c("br"),
                _vm._v(
                  "\n      2.4\n      为了更好的完成服务以及提升用户体验等目的，平台亦将为您提供更为友好完善的平台服务，并优化和引入第三方服务。由此发生的法律关系是由您和该等第三方服务商之间形成，和平台无关。"
                ),
                _c("br"),
                _vm._v(
                  "\n      2.5\n      您同意并知悉，平台中的具体内容、功能和形式由平台根据实际情况按实际可见的状态提供，我们有权自行确定平台服务的具体内容、功能和形式（例如，我们可能仅在特定的国家或地区以特定的语言提供），有权自行决定增加、变更、中断和停止平台具体的内容、功能和形式。具体以平台实时呈现的服务内容、功能和形式为准。为保证您能正常享受平台提供给您的服务，您在接受平台给您提供的具体服务过程中应遵守的细则，应以税智汇通知的为准。"
                ),
                _c("br"),
                _vm._v(
                  "\n      2.6您同意并知悉，您购买的服务内容包含了税智汇为您提供的合规认证系统软件服务。如您购买税智汇EPR注册服务的，税智汇提供的服务时间为购买的服务对应的自然年（当年1月1日至12月31日）；您购买税智汇授权代表服务的，服务时间自下发英代/欧代/美代协议之日起一算年；您购买税智汇认证服务服务的，服务时间为自您付款完成之日起至服务提供完毕之日止。您的合规认证服务期限与税智汇为您提供的“[合规认证]”系统软件服务期限保持一致。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("第3条 用户使用规范")]),
                _vm._v("\n      （一）办理能效标签认证服务"),
                _c("br"),
                _vm._v(
                  "\n      3.1.1您应保证所提供的产品材料真实有效且测试样品材质与最终销售产品材质的一致，若因您提供虚假产品材料或提供测试产品材质与最终销售产品不符，导致的责任追究，税智汇无须承担责任。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.1.2如税智汇对您产品进行检测，检测后发现达不到合规标准（对应区域/国家要求的产品标准），您应在收到税智汇书面通知后2个工作日内，保证新送样和合格的资料到达税智汇，积极配合税智汇整改直至达标。因您原因导致您未按照税智汇反馈结果进行整改，税智汇有权暂停认证服务，给税智汇造成损失的，您应赔偿税智汇实际损失。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.1.3您应指定专人积极配合认证工作，保证其顺利进行。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.1.4您应积极履行对税智汇工作进度、工作完成状况等的监督义务，若认证工作中存在问题，您有权向税智汇进行申诉，税智汇在收到申诉后应予以合理答复并对工作中存在的问题进行改善、修正。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.1.5如税智汇收到的您提供的测试样品与您询价时提供的产品图片不符的，或测试项目有变化的，税智汇保留重新定价及确定测试时间的权利，并有权于发现样品问题后与您重新书面约定。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.1.6税智汇会向您确认样品处理方式，若 税智汇在30\n      日内未收到您任何有关样品处理的回复（包括是否需寄回给您）或您未要求退样并承担退样费用的，税智汇有权自动取消测试和销毁样品。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.1.7您支付的费用不包含产品的整改、重测费用。您寄送样品的快递费用以及退样费用由您自行承担。如您在税智汇出具正式证书报告后，出现您申请表内容修改，导致税智汇修改证书报告的，税智汇有权收取修改费。"
                ),
                _c("br"),
                _vm._v("\n\n      （二）办理EPR服务"),
                _c("br"),
                _vm._v(
                  "\n      3.2.1您应积极配合税智汇工作并提交服务所需的全部资料，包括但不限于您的营业执照、法人证件、店铺链接、增值税税号、亚马逊/速卖通/阿里巴巴国际站等对应电商平台ID、联系邮箱（接收信息及证书等）。若您未按照税智汇要求提交资料，在税智汇合理提示规定的期限内仍未提交，由此造成的损失由您自行承担。如因申报目的国政策调整，税智汇将通知您调整提供资料的时间，您应当配合。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.2.2服务期内，您有任何法律及工商变更，包括但不限于法定代表人变更、公司名称、公司地址变更、联系人变更等情形出现时，应当提前5个工作日书面通知税智汇，并提供相应证明文件；因未告知税智汇造成的全部损失由您自行承担。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.2.3您提供的注册信息需与实际销售信息保持一致，并对其真实性、完整性、合法性负责。材料一经提交，则无法更改，无法撤销。如因您提供的资料与实际销售信息不一致或失实，导致委托事项无法完成，产生的相应法律责任及损失，由您承担；如因此造成税智汇损失的，您还需赔偿税智汇实际损失。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.2.4您承诺将会在目的国申报截至日期前7个工作日向税智汇提供所需的资料，您对其提供资料的真实性、完整性、合法性负责，自提交之后不再进行修改或重复提交。如您未及时提供资料或提供资料有问题，导致的相应法律责任，由您承担；如因此造成税智汇损失的，您还需赔偿税智汇实际损失。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.2.5收到税智汇同步申报回收费后，您应在一个工作日内核对金额无误，并在目的国申报截止日期前，一次性支付回收费用，因逾期支付、不支付产生的罚款等其他后果由您承担；如因此造成税智汇损失的，您还需赔偿税智汇实际损失。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.2.6若您要求取消申报或者终止服务，您应提前30个自然日告知税智汇并签署取消代理相关确认文件，税智汇书面同意后可以终止代理服务，对于具体服务的终止流程和终止时间，以主管当局的流程为准。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.2.7您不得授意税智汇及其代理人员实施违反中国和目的国法律、法规的行为。如有此类情况，经税智汇劝告仍不停止的，税智汇有权解除合同，所收费用不予退还，并不承担任何违约责任。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.2.8您应按照本合同约定支付代理服务费，因逾期支付或者不支付服务费用所造成的周期延误，后果由您承担；如因此造成税智汇损失的，您还需赔偿税智汇实际损失。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.2.9您应在委托代理事项当年的11月30日前通知税智汇是否续费；若您不续费，则需书面通知税智汇进行注销操作，并由您承担相应注销费用。如因您未在约定时间内通知或未书面告知税智汇注销的，造成的法律责任及相应费用由您承担。如德国WEEE和电池法服务到期后您选择不续费也不告知转走的，税智汇有权到期后直接注销；如德国包装、法国EPR服务到期后不续费的，到期后税智汇将有权力移除授权关系。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.2.10您作为合规注册服务的最终使用方，有义务对合规服务的规范要求负责，承担一切责任，税智汇不对您在目标市场所在国的销售合法性负责。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.2.11您享有对税智汇工作进度、工作完成状况等的监督权利，若委托服务工作中存在问题，您有权向税智汇进行申诉，税智汇在收到申诉后应予以合理答复并对工作中存在的问题进行改善、修正。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.2.12税智汇在收到您提供的申报数据后，对于在标准服务包中已涵盖内容的，不再另行收费；如果您申报数量超出标准服务包，在确认您的申报数量后，税智汇将负责与当地主管当局和回收机构沟通确认，重新给您出具超出标准服务包的价格。您确认无误并付款后，税智汇再按照委托内容提交申报并反馈申报结果。"
                ),
                _c("br"),
                _vm._v("\n\n      （三）办理授权代表服务"),
                _c("br"),
                _vm._v(
                  "\n      3.3.1您确保在认证结束后向税智汇提供每一大类需做UKCA/CE/CPC等检测认证产品的最新技术文档。如果您在授权英代/欧代/美代代理您产品之后30天内，或者“自我声明”产品在使用合规信息之前，仍然没有提供给税智汇符合要求的产品技术文档，本协议自动失效，您承担由此而引起的所有后果。其书面文件只有在英国/欧盟/美国当局需要审核时才提交税智汇。如您未能在英国/欧盟/美国当局要求时间内提交书面及电子版文件的，导致的相应法律责任，由您承担。"
                ),
                _c("br"),
                _vm._v(
                  "\n      所提交文档内容的要求如下：（以下指欧代和英代，美代提供检测报告即可）"
                ),
                _c("br"),
                _vm._v("\n      （1）符合性声明；"),
                _c("br"),
                _vm._v(
                  "\n      （2）标签、包装、说明书副本（所有上市国家要求的语言的版本）；"
                ),
                _c("br"),
                _vm._v("\n      （3）公告机构证书（适用时）；"),
                _c("br"),
                _vm._v(
                  "\n      （4）上市监测进程和数据、警告和投诉、流程和数据；"
                ),
                _c("br"),
                _vm._v(
                  "\n      （5）供应商将UKCA/CE标记的设备投放市场/供应商的详细信息；"
                ),
                _c("br"),
                _vm._v("\n      （6）其他应提交材料。"),
                _c("br"),
                _vm._v(
                  "\n      3.3.2您产品如有改变、技术文件如有更新，您需要在更新信息产生后3个工作日内书面告知税智汇。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.3.3如您产品发生任何意外/近乎意外事故，您应及时配合税智汇调查原因，并与税智汇一起完成初步报告。如产品事故发生在英国/欧盟/美国以外，您应即时通知税智汇，并由税智汇决定是否向主管部门报告。如您事先知道上述事故/近乎意外事故，您必须在1个工作日内告知税智汇。并提供调查、分析报告，于相关事故发生后一周内向税智汇报告事故/近事故的处理结果。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.3.4您应对与其产品问题有关的任何商业纠纷负责，如医疗事故或销售后出现的质量赔偿要求。税智汇根据您的授权，协助您处理争议，税智汇处理事故期间，调查、取证、索赔等相关费用，由您确认后由您承担。税智汇可以要求您支付相应的预付款，在该预付款到达税智汇指定账户之前，税智汇有权拒绝代为支付或者采取相应措施。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.3.5您出口英国/欧盟地区、EEA、瑞士、土耳其/美国之所有产品的销售清单（包括OEM的销售清单），在产品停产后至少五年内，必须用英文文字、电子文档形式保留完整无缺，以备税智汇随时用于英国/欧盟地区、EEA、瑞士、土耳/美国其官方的调用、检查。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.3.6您必须对委托事项有关的资料及数据的其真实性、完整性、合法性负责。若因您提供的资料问题导致委托事项无法完成的损失及相关法律责任，由您承担，税智汇可解除与您的合作关系，费用不退还；如因您的违规行为使得税智汇及目的国授权代表受到海外当局处罚及遭受损失的，税智汇有权要求您承担因此造成的一切损失。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.3.7您针对客户/用户事故的投诉记录和处理结果，除了应该及时通知税智汇以外，所有记录的保存、调用、检查，按照本条第5款办理。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.3.8您应充分认识到本企业产品不加贴UKCA/CE标志或不满足英国/欧盟法规要求却向英国/欧盟市场销售产品的风险，如果因为您延迟或隐瞒文件提交而引起的，您应当承担所有后果，如警告、处罚甚至UKCA/CE证书被撤销，并禁止在英国/欧盟销售其产品。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.3.9您对其产品的性能承担全部责任，并将使税智汇免于因使用您生产或销售的产品而引起的任何责任索赔。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.3.10如果税智汇因提供本合同规定的服务而产生对第三方的赔偿责任，您应当全权承担相关赔偿责任，并免除税智汇对外的责任。税智汇由此需要聘请专家和顾问，特别是法律顾问提供咨询和法律代理的，您应承担税智汇因此而产生的相关费用，税智汇有权要求您预付相关费用。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.3.11您不得以税智汇英国/欧盟/美国公司名义经营活动或其他有损税智汇英国/欧盟/美国公司的行为，否则税智汇有权追究您法律责任及造成的经济损失。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.3.12英国/欧盟授权代表关系生效后，您需严格执行产品和包装上的标示义务且您必须用当地官方语言在出口产品的包装上印制生产商或经销商的联系信息，以便客户联系到生产商或者经销商。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.3.13您需明确税智汇提供的英国/欧盟/美国授权代表并非您的进口商，您不得以税智汇提供的英代/欧代/美代为进口商名义进行一系列活动，同时，您在被英国/欧盟相关机构调查时，您需如实向其阐述自己的身份（您为英国/欧盟境外的制造商，依据法规只有英国/欧盟/美国境外的制造商才需要英代/欧代/美代），如需联系英国/欧盟/美国相关政府机构时，需提前告知税智汇，经税智汇审核邮件等相关联系内容合格后，方可进行。如您未按以上操作进行或阐述不实，由此造成的损失由您承担。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.3.14您享有对税智汇工作进度、工作完成状况等的监督权利，若授权代表服务工作中存在问题，您有权向税智汇进行申诉，税智汇在收到申诉后应予以合理答复并对工作中存在的问题进行改善、修正。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.3.15若您收到亚马逊 CPSC 要求制定检查您工厂的时间表的指令，您须在三个工作日内按亚马逊\n      CPSC的要求配合税智汇制定出检查时间表并提交税智汇转交亚马逊 CPSC 审定。 "
                ),
                _c("br"),
                _vm._v(
                  "\n      3.3.16当您所购买的“[合规认证]”系统服务到期时，您应及时向税智汇续费，否则，税智汇有权停止提供服务。如因您没有及时续费而造成使用“[合规认证]”系统服务停止，税智汇不承担责任。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.3.17您只能于您业务范围内使用服务，禁止出售、转售或复制、开发使用权限，禁止对软件进行全部或部分地翻译、分解、反向编译、反汇编、反向工程或其他试图从软件导出程序源代码的行为，或在软件的基础上书写或开发衍生软件、衍生产品或其他软件。禁止复制和模仿税智汇的设计理念、界面、功能和图表。禁止未经税智汇许可基于此项服务或内容进行修改或制造派生其他产品。禁止您限制、破坏或绕过软件的加密措施。禁止您去除、掩盖或更改软件上有关软件著作权或商标的标志。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.3.18申请项目【英国/欧盟/美国授权代表】价格包含地址服务（为服务公司在服务国家/地区市场的产品授权代表，提供真实有效的授权代表名称、地址、邮箱、电话），确认代理关系等。如果服务公司的产品发生事故或质量等问题，可能引发索赔纠纷、产品召回、库存处理\n      和销毁等，由此产生的费用应由您承担，如果由于调查、取证质量投诉、事故和索赔的需要而产生的费用，也应由您自行承担。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.3.19您应在英代/欧代/美代服务到期日前一个月书面通知税智汇是否续签合同。如果合同终止，所有含有税智汇提供的英国/欧盟/美国授权代表信息的产品应在到期日前处理，税智汇将在合同正式到期后随机测试购买您的产品，并防止继续使用英国/欧盟/美国代表的情况。一旦发现上述情形，税智汇将直接联系律师和相关部门，您至少需赔偿5000欧元。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.3.20税智汇不对您提供的UKCA/CE等技术文档的内容负责。税智汇对您提供的销售清单、投诉记录等文件，负责递交英国/欧盟/美国相关机构审阅并负有保管、保密的责任。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.3.21税智汇应将有关UKCA/CE/CPC等产品在英国/欧盟/美国境内的相关消息（包括客户投诉和同类竞争企业）及时通知您。协助您理解英国/欧盟/美国境内同类产品的状况。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.3.22针对特殊产品（具体以税智汇告知为准），税智汇有权利要求您提供销售的产品包装照片，保证提交备案产品与最终销售产品一致，否则有权取消合作。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.3.23税智汇不是您的进口商或者销售商，除上述职责外，税智汇不负责其他法律责任和义务，税智汇提供的英国/欧盟授权代表/美国授权代表信息仅限于申请公司使用，未经许可严禁在其他公司使用。\n      "
                ),
                _c("br"),
                _vm._v(
                  "\n      3.3.24如果您与 AMAZON CPSC\n      在任何问题上发生争执，税智汇没有义务提供任何法律咨询。税智汇也无需在产品的设计、生产、包装、标签、储存、安装、维修和产品档案的保存等\n      AMAZON CPSC 所要求的质量系统管理和控制的问题上为您提供建议。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.3.25在 AMAZON CPSC 规定的医疗器材事故报告制度上，税智汇不提供任何行政方面的服务，除了需要时，就此事促成\n      AMAZON CPSC 和您的双向联系。(在这个报告制度下，工厂必须向 AMAZON CPSC\n      报告其产品造成或者可能造成的死亡或伤亡事故，工厂必须保存这些事故的档案，工厂必须提供给 AMAZON CPSC\n      —份事故处理结果和总结报告，等等) 。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.3.26税智汇没有义务协助您向 AMAZON CPSC 申请其产品出口到美国的许可证及其所有手续。 "
                ),
                _c("br"),
                _vm._v(
                  "\n      3.3.2711、有关您的产品介绍、生产过程、质量控制等一系列问题，税智汇不提供翻译服务。除了需要时，就这些事促成\n      AMAZON CPSC 与您的联系。 "
                ),
                _c("br"),
                _vm._v("\n\n      （四）”[合规认证]”系统服务"),
                _c("br"),
                _vm._v(
                  "\n      3.4.1\n      税智汇提供“[合规认证]”系统服务的统一优化升级、维护，并就系统服务过程发生的任何程序故障、异常提供及时响应，并第一时间安排专人对接完成修复工作；"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.4.2\n      税智汇有权对“[合规认证]”系统上您发布、推广的内容进行监督，如有涉及违反法律、法规或任何第三方合法权利的内容、文字、链接等，税智汇有权立刻删除。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.4.3\n      税智汇保证“[合规认证]”系统不侵犯任何第三方的专利权、著作权、商标专用权、商业秘密及其他权属权利，因本合同“[合规认证]”系统软件及文档而产生的知识产权法律纠纷由税智汇承担责任。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.4.4\n      “[合规认证]”系统服务的应用程序、源代码、LOGO、界面设计、应用程序编程接口（API）所关联的所有知识产权归属[税智汇]。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.4.5 税智汇在培训、实施、维护等服务过程中提供的软件、文档之版权及著作权均归税智汇所有。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("第4条 用户帐号规则")]),
                _vm._v(
                  "\n      4.1\n      您在注册或使用平台服务时可能需要提供一些必要的信息。您须保证所填写及所提供的资料真实、准确、完整，否则可能无法使用平台服务，或在使用过程中受到限制，甚至影响您是否能够使用平台特定功能。对于因您提供的信息不真实、不准确或不完整导致的责任和损失由您承担。"
                ),
                _c("br"),
                _vm._v(
                  "\n      4.2\n      平台有权根据您所提供资料的真实性、准确性、完整性以及是否符合平台服务规定的其他条件，决定是否为您提供服务。您在使用平台服务过程中，所提供的信息发生变动，应及时进行变更。"
                ),
                _c("br"),
                _vm._v(
                  "\n      4.3\n      您注册成功后，我们将为您配置帐号，该帐号之所有权归平台所有，用户在本协议有效期内仅享有使用权。未经平台同意，用户的帐号仅供用户本人使用，帐号信息和权限不得以转让、赠与、借用、售卖、授权或租用等方式许可给第三方使用或和第三方共同控制、使用。"
                ),
                _c("br"),
                _vm._v(
                  "\n      4.4如果您需要注销您的帐号，您有权通过平台公布的方式、程序进行，我们将在核实您的身份并清理帐号资产（例如已充值或已获得的虚拟资产等）及纠纷争议后，为您提供帐号注销服务。在注销帐号之后本协议即终止，我们将停止为您提供任何服务。同时对您的平台的所有数据将不做保存。当然，我们也保留权利在您的帐号符合回收的如下情况下，直接回收并注销您的帐号并停止服务：（1）未通过实名认证；（2）其它情况。"
                ),
                _c("br"),
                _vm._v(
                  "\n      4.5\n      用户一经注册，即可能可以在平台及我们关联公司运营的其它产品，或者合作伙伴等第三方平台中通行使用。在使用平台服务帐号登录并使用其他产品或服务时，除遵守本协议约定外，还应遵守该等产品的服务协议的约定。平台服务和其他产品对可能出现的纠纷在法律规定和约定的范围内各自承担责任。"
                ),
                _c("br"),
                _vm._v(
                  "\n      4.6为客户体验及功能服务考虑，您在使用不同服务时被要求填写的信息内容可能不完全一致，因此，为了给您提供更好的服务及为了您的登录帐号安全，可能需要您补充完整信息后方可使用。"
                ),
                _c("br"),
                _vm._v(
                  "\n      4.7您有责任自行负责保管帐号的用户名和密码等信息，否则因该等事项引发的法律责任由用户自行承担。凡使用平台服务登录帐号和登录凭证的行为，平台服务视为您本人的操作，操作所产生的电子信息记录均为平台服务用户行为的有效凭据。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("第5条 用户行为规范")]),
                _vm._v(
                  "\n      5.1 您保证合理地使用平台服务，并接受本协议和我们适时制定并发布的其他政策、规则、公告声明。"
                ),
                _c("br"),
                _vm._v(
                  "\n      5.2 行为禁止：您可在本协议约定的范围内使用平台及服务，您不得利用平台从事以下行为："
                ),
                _c("br"),
                _vm._v("\n      （1）超出授权或恶意使用平台服务；"),
                _c("br"),
                _vm._v(
                  "\n      （2）利用平台发表、传送、传播、储存危害国家安全、国家统一、社会稳定的内容，或侮辱诽谤、色情、暴力、引起他人不安及任何违反国家法律法规政策的内容，或者设置含有上述内容的网名、角色名，发布、传送、传播违法广告信息、营销信息及垃圾信息等；"
                ),
                _c("br"),
                _vm._v(
                  "\n      （3）利用平台侵害他人知识产权、肖像权、隐私权、名誉权、个人信息等合法权利或权益；"
                ),
                _c("br"),
                _vm._v(
                  "\n      （4）恶意虚构或协助虚构事实、评价等信息或数据；"
                ),
                _c("br"),
                _vm._v(
                  "\n      （5）进行任何危害计算机网络安全的行为，包括但不限于：使用未经许可的数据或进入未经许可的服务器/账户；未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；未经许可，企图探查、扫描、测试本“软件”系统或网络的弱点或其它实施破坏网络安全的行为；企图干涉、破坏本“软件”系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；伪造TCP/IP数据包名称或部分名称；利用平台及服务上传任何病毒、木马，或者蠕虫等危害网络健康的内容；"
                ),
                _c("br"),
                _vm._v(
                  "\n      （6）对平台进行反向工程、反向编译或反向汇编或以其它方式企图发现平台的源代码和算法，未经许可修改、禁用软件的任何功能或创建基于软件的衍生作品。去除平台或文档上的任何所有权声明或标签，或将其他软件与平台合并；"
                ),
                _c("br"),
                _vm._v(
                  "\n      （7）进行任何破坏我们提供服务公平性或者其他影响应用正常秩序的行为，如主动或被动刷分、合伙作弊、使用外挂或者其他的作弊软件、利用BUG（又叫“漏洞”或者“缺陷”）来获得不正当的非法利益，或者利用互联网或其他方式将外挂、作弊软件、BUG公之于众；"
                ),
                _c("br"),
                _vm._v(
                  "\n      （8）从事其他法律法规、政策及公序良俗、社会公德禁止的行为以及侵犯其他个人、公司、社会团体、组织的合法权益的行为。"
                ),
                _c("br"),
                _vm._v(
                  "\n      5.3\n      信息内容规范：为了营造良好网络生态，保障公民、法人和其他组织的合法权益，维护国家安全和公共利益，我们将根据《中华人民共和国国家安全法》《中华人民共和国网络安全法》《互联网信息服务管理办法》等法律、行政法规，自觉践行社会主义核心价值观，营造清朗的网络空间，并开展的弘扬正能量、处置违法和不良信息等相关活动。"
                ),
                _c("br"),
                _vm._v("\n      5.4 信息内容的使用规范"),
                _c("br"),
                _vm._v(
                  "\n      5.4.1 未经我们书面许可，您不得自行或授权、允许、协助任何第三人对平台中信息内容进行如下行为："
                ),
                _c("br"),
                _vm._v(
                  "\n      （1）复制、读取、采用平台的信息内容，用于任何形式的商业用途；"
                ),
                _c("br"),
                _vm._v(
                  "\n      （2）擅自编辑、整理、编排平台及相关服务的信息内容后在平台及相关服务的源页面以外的渠道进行展示；"
                ),
                _c("br"),
                _vm._v(
                  "\n      （3）采用不正当方式，自行或协助第三人对平台及相关服务的信息内容产生流量、阅读量或交易引导、转移、劫持等不利影响。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("第6条 个人信息保护与隐私政策")]),
                _vm._v(
                  "\n      6.1\n      尊重用户隐私并保护您的个人信息安全是我们的一贯态度，平台将会采取合理的措施保护您的个人信息与隐私。我们承诺，除非获得用户同意，平台不会收集、使用其提供服务所必需以外的用户个人信息或者将信息用于提供服务之外的目的。但是平台因需要向注册国政府及税局等机关提交资料的情形除外。\n      "
                ),
                _c("br"),
                _vm._v(
                  "\n      6.2 在您使用本平台的过程中，平台将遵循合法、正当、必要的原则，收集您的相关信息，包括但不限于："
                ),
                _c("br"),
                _vm._v(
                  "\n      （1）用户注册或登录的账户信息，例如用户注册账户使用的电话号码、姓名或昵称、公司名等信息；"
                ),
                _c("br"),
                _vm._v(
                  "\n      （2）用户用于办理合规认证服务上传的信息，例如用户的营业执照、销售数据等用户主动填写的信息或用户与平台客服联系时提供的相关信息等；"
                ),
                _c("br"),
                _vm._v(
                  "\n      （3）用户使用平台过程中产生的信息。平台会根据用户授予的权限，接收并记录用户所使用的设备相关信息，例如设备属性信息、设备位置信息、设备连接信息等；"
                ),
                _c("br"),
                _vm._v(
                  "\n      （4）平台根据用户授权通过合法方式收集的其他用户信息。 "
                ),
                _c("br"),
                _vm._v(
                  "\n      6.3\n      安全保护：我们将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息及隐私安全，以免遭受未经授权的访问、使用或披露。"
                ),
                _c("br"),
                _vm._v(
                  "\n      6.4\n      信息使用与披露：我们有权在遵守法律法规的前提下，以明示的方式获取、使用、储存和分享您的个人信息。我们不会在未经您授权时，公开、编辑或透露您的个人信息及您保存在我们的非公开内容。您同意并保证：平台有权根据我们制定的个人信息保护规则收集使用您的相关信息。"
                ),
                _c("br"),
                _vm._v(
                  "\n      6.5\n      您同意，我们有权通过cookie等技术收集您的使用、行为信息，并在经过数据脱敏使之不再指向、关联到您个人的身份信息时，自由使用脱敏后的纯商业数据。当然，您也可根据自己的偏好删除Cookie，但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。目前删除Cookie的一般路径是浏览器：“设置-清除数据”，或者将手机系统还原/清除。"
                ),
                _c("br"),
                _vm._v(
                  "\n      6.6\n      在遵守本协议项下特别约定的个人信息保护与隐私政策外，我们希望您认真并完整阅读我们特别针对平台而制定并适时发布的《隐私权政策》，这将更有助于保障您的个人信息。"
                ),
                _c("br"),
                _vm._v("\n      6.7 税智汇以下行为不受此条款的限制："),
                _c("br"),
                _vm._v(
                  "\n      ①因实现本合同目的需要向目的国政府及税局等机关提交相关资料；"
                ),
                _c("br"),
                _vm._v(
                  "\n      ②应政府部门等机构要求或办理业务需要，向政府部门等相关机构提交相关资料；"
                ),
                _c("br"),
                _vm._v(
                  "\n      ③因外部审计等需要而向律师事务所、会计师事务所等中介机构提供相关资料。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("第7条 信息或广告推送")]),
                _vm._v(
                  "\n      7.1\n      您同意在接受我们提供服务的同时，允许我们在遵守法律法规的前提下自行或由第三方广告商向您发送、展示广告、推广或宣传信息（包括商业与非商业信息）。如您对发送、推荐的广告或信息不感兴趣，您可以基于我们提供的相关技术选项，控制系统向您展示或不展示/减少展示相关类型的广告或信息。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("第8条 知识产权等权益")]),
                _vm._v(
                  "\n      8.1\n      我们对平台中所包含的受知识产权或其他法律保护的资料享有相应的权利；除依法由用户享有著作权的内容之外，平台的整体内容的知识产权归我们或关联公司所有。"
                ),
                _c("br"),
                _vm._v(
                  "\n      8.2关于信息内容的投诉或举报。若您在使用平台过程中，不慎受到合法权益的侵犯，您有权通知我们采取必要措施进行处置。若您在使用平台过程中，发现存在违法违规或违反本服务相关规则的情况，您也有权向我们发起举报，我们亦会及时采取必要措施（删除、屏蔽、断开链接或限制使用功能等）进行处置。"
                ),
                _c("br"),
                _vm._v(
                  "\n      8.3内容维权授权。在法律法规允许的范围内，您同意并授权我们就侵犯您合法权益的行为（包括但不限于私自复制、使用、编辑、抄袭等行为）采取任何形式的法律行动，包括但不限于投诉、诉讼等必要的维权措施。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("第9条 免责声明")]),
                _vm._v(
                  "\n      9.1\n      我们对于您自平台而获得的所有他人、第三方的信息、内容或者广告宣传等任何资讯（以下统称“信息”），除法律明确规定外，不保证真实、准确和完整性。如果任何单位或者个人通过上述“信息”而进行任何行为，您须自行甄别真伪和谨慎预防风险。您在接受平台及服务时，有可能会接触到令人不快、不适当或令人厌恶的内容，在任何情况下，我们均不对任何此等内容承担任何责任。无论何种原因，我们不对任何非与我们直接发生的交易或行为承担任何直接、间接、附带或衍生的损失和责任。"
                ),
                _c("br"),
                _vm._v(
                  "\n      9.2\n      鉴于互联网服务的特殊性，您理解并同意我们在以下情况下无需对您所遭受的损失（包括但不限于财产、收益、数据资料等方面的损失或其它无形损失）承担责任："
                ),
                _c("br"),
                _vm._v(
                  "\n      （1）因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素导致平台及服务障碍不能正常运作；"
                ),
                _c("br"),
                _vm._v(
                  "\n      （2）由于计算机病毒、木马、其他恶意程序、黑客攻击、电信部门及网络运营公司技术调整或故障、系统维护等意外原因而造成平台及服务中断或延迟。"
                ),
                _c("br"),
                _vm._v(
                  "\n      9.3\n      平台有权不时对提供的所有服务实施优惠政策或开展优惠活动，该等优惠政策或优惠活动以平台发布的实时信息为准，您知悉并认可，平台有权自行决定是否提供优惠政策或开展优惠互动，以及优惠政策或优惠活动的内容、条件和有效期，并不时进行调整或。对于不同活动期内不同的价格，平台不允诺担保您享有的是最低服务价格。"
                ),
                _c("br"),
                _vm._v(
                  "\n      9.4\n      有限责任：平台在适用法律所允许的最大范围内，不论出于何种原因，平台对您的全部责任为您使用本平台产品和服务而向平台支付的费用总额。如果平台免费向您提供了服务，则平台无义务对您承担任何赔偿责任。任何情况下，平台不对出自本协议或与本协议有关的或与平台的运行有关的任何特殊的、偶然的、惩罚性或间接的损害（包括但不限于数据损失、利润损失或营业损失）或采购替代产品承担责任，不论该等责任是基于合同、担保、侵权（包括过失）、严格责任或其他，也不论平台是否被事先告知了损失或损害发生的可能性。即使本协议约定的有限补救措施未能实现其根本目的，前述的责任限制依然适用。"
                ),
                _c("br"),
                _vm._v(
                  "\n      9.5\n      如果您通过合法方式获得了相关付费服务的优惠券或折扣等其他优惠方式的，则用户知悉并认可，该等优惠券或折扣必须满足一定条件才能使用，以优惠券上的信息提示和优惠券使用说明、或平台公示的折扣使用说明为准。优惠券或折扣不兑现（即不直接兑换现金）、不找零（即订单金额不足抵用券金额的，抵用券剩余金额无效）、过期作废；优惠券或折扣仅限同一用户账号使用，严禁出售、转让或共享，如经平台发现存在出售、转让或共享优惠券或折扣等其他优惠方式的，该优惠券或折扣将予以作废处理，且平台有权视情节严重程度予以封号处理，并保留追究相关责任人法律责任的权利。"
                ),
                _c("br"),
                _vm._v(
                  "\n      9.6 免责：如因下所列任何原因而造成的用户资料泄露、丢失、被盗用或被篡改等，平台均有权获得免责："
                ),
                _c("br"),
                _vm._v(
                  "\n      （1）任何因政府管制而造成的暂时性关闭等影响网络正常浏览的不可抗力原因；"
                ),
                _c("br"),
                _vm._v(
                  "\n      （2）任何计算机系统问题、黑客攻击、计算机病毒侵入或发作的原因；"
                ),
                _c("br"),
                _vm._v(
                  "\n      （3）任何因网络安全问题导致的账户或银行卡信息泄露，该风险可能会给用户造成经济损失，用户承诺自行承担向侵权方追究责任及追究责任不能的后果；"
                ),
                _c("br"),
                _vm._v(
                  "\n      （4）任何因用户个人原因导致的用户资料泄露、丢失、被盗用或被篡改等；"
                ),
                _c("br"),
                _vm._v("\n      （5）其他不能归责于公司的原因。"),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("第10条 违约责任")]),
                _vm._v(
                  "\n      10.1\n      如果我们发现、收到他人举报或投诉您违反本协议约定或违反法律法规和国家有关规定的，我们有权采取警示、冻结、终止/中止/限制使用帐号等功能、解除或终止本协议，或提出损害赔偿等措施。"
                ),
                _c("br"),
                _vm._v(
                  "\n      10.2\n      若您的行为给我们造成损失的（包括但不限于直接损失、名誉损失、第三方的罚款、索赔等），我们有权全额向您追偿，如您在平台中有保证金、虚拟货币等财产或优惠券等虚拟权益的，我们有权冻结。"
                ),
                _c("br"),
                _vm._v(
                  "\n      10.3\n      本协议终止后，除法律有明确规定外，平台无义务向您或您指定的第三方披露您账户中的任何信息。本协议终止后，平台仍享有下列权利：根据法律规定，继续保存您留存于平台的的各类信息；对于您过往的违约行为，平台仍可依据本协议向您追究违约责任。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("第11条 退款规则")]),
                _vm._v(
                  "\n      11.1您知悉并确认仅符合如下条件之一，税智汇才会将您支付的相关服务费全部或部分退还给您："
                ),
                _c("br"),
                _vm._v(
                  "\n      ①\n      由于市场变化及各种因素的影响，税智汇无法保证您提交的申请委托服务都能提供，如您拟购买的服务发生“暂时无法提供服务”的情况，您和税智汇均有权取消订单，并全额退还已支付的案件相关费用。"
                ),
                _c("br"),
                _vm._v(
                  "\n      ②您成功购买服务后，如您在向提交资料前向税智汇提出终止或解除本合同的，税智汇有权要求您承担服务费总额20%的违约金，如您已支付部分/全部服务费，税智汇有权直接从您已支付费用中进行扣除；如您在向税智汇提交材料后提出终止或解除本合同的，税智汇有权要求您全额支付本协议项下的服务费，且不予退还您已付费用。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("第12条 法律适用与管辖")]),
                _vm._v(
                  "\n      12.1 本协议的订立、执行、解释及争议的解决均适用中华人民共和国法律。"
                ),
                _c("br"),
                _vm._v(
                  "\n      12.2\n      如双方就平台服务协议内容或其履行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向税智汇所在地人民法院提起诉讼。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("第13条 如何联系我们")]),
                _vm._v(
                  "\n      如果您有任何的疑问、投诉、意见和建议，欢迎您与我们沟通反馈。我们的联系方式见下："
                ),
                _c("br"),
                _vm._v("\n      联系电话：4001828088"),
                _c("br")
              ])
            : _c("div", { staticClass: "content" }, [
                _c("div", { staticClass: "header" }, [_vm._v("服务协议：")]),
                _vm._v(
                  "\n\n      欢迎您使用税智汇商标服务商标及外观设计专利咨询服务！"
                ),
                _c("br"),
                _vm._v(
                  "\n\n      本服务协议是您（或称“用户”）与税智汇之间（“税智汇”是指深圳市税智汇网络科技有限公司和/或其相关服务可能存在的运营关联单位），就为您本人及/或您所代表或代理的第三方，通过使用税智汇商标专利服务平台（以下简称“平台”）提供的税智汇商标及外观设计专利咨询服务（以下简称“本服务”），进行商标注册和外观设计专利咨询服务相关事宜所订立的有效合约。"
                ),
                _c("br"),
                _vm._v(
                  "\n      在接受本服务协议并使用税智汇商标服务前，请您务必仔细阅读、充分理解本服务协议的全部内容，并在确认接受本服务协议后再进行后续操作。如果您对本服务协议的条款有疑问的，请向本平台咨询，本平台将向您解释条款内容。如果您不同意本服务协议的任意内容，或者无法准确理解本平台对条款的解释，请不要进行后续操作。"
                ),
                _c("br"),
                _vm._v(
                  "\n      当您通过网络页面直接确认、接受引用本页面链接及提示遵守内容、线下签署书面协议、实际使用本服务、或以税智汇认可且符合法律法规惯例的其他任一方式确认本服务协议后，即表示您已充分阅读、理解并接受本服务协议的全部内容，并与税智汇达成一致，本服务协议对双方均具有法律约束力。届时您不应以未阅读本服务协议的内容或者未获得本平台对您问询的解答等理由，主张本服务协议无效，或要求撤销/变更本服务协议内容。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("一、协议内容和效力")]),
                _vm._v(
                  "\n\n      1.1 本服务协议内容包括税智汇官网相关页面上的服务说明、价格说明和您确认同意的订购页面、订单信息等，以及税智汇官网已经发布的或将来可能发布的与本服务相关的各类政策、规则、声明、通知、服务条款等，以上均为本服务协议不可分割的组成部分，与协议正文具有同等法律效力。"
                ),
                _c("br"),
                _vm._v(
                  "\n      1.2 税智汇有权根据需要不定时制订、修改本服务协议及各类规则，并以网站公示的方式进行公告，不再另行通知您，协议及规则的修改也不以您的同意或事先通知为前提。变更后的协议和规则一经公布，立即自动生效。如您不同意相关变更，应当立即停止使用本服务。若您继续使用本服务的，即表示您接受经修订的协议和规则。"
                ),
                _c("br"),
                _vm._v(
                  "\n      1.3 本服务协议的签署及履行，须通过您的税智汇注册账号进行，对您具有法律约束力。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("二、服务内容")]),
                _vm._v(" "),
                _c("h3", [_vm._v("（一）商标服务")]),
                _vm._v(
                  "\n      2.1 税智汇商标注册服务，是指本平台向您提供的一项商标注册申请服务，包括在线提交商标注册申请、向商标局递交、跟踪及完成商标注册全流程的平台及相应的“[商标]”系统技术服务和支持。"
                ),
                _c("br"),
                _vm._v(
                  "\n      2.2 您理解并同意，您通过税智汇商标服务提交的商标注册是否成功取决于商标标志本身及申请时间等因素，并最终由商标局依法审查后决定。税智汇不会以任何明示或者暗示的方式担保您提交的商标注册申请能够成功，且对您的商标注册是否成功不承担法律有明确规定之外的责任。如果您要求百分之百的成功率或其他任何效果，税智汇无法做出承诺，因此请您慎重考虑是否继续使用本服务。"
                ),
                _c("br"),
                _vm._v(
                  "\n      2.3 税智汇有权对您提交的拟申请商标进行初步审核，如果认为商标本身或商标申请行为不合法或不符合商标注册申请约定，税智汇有权随时终止本次商标申请服务。"
                ),
                _c("br"),
                _vm._v(
                  "\n      2.4 商标注册为单次服务，如您在商标审查过程中需要提起不予补正答复、注册复审、驳回复审、异议答辩等，或需要对已申请注册的商标改变其标志的，您均应另行购买相应的税智汇服务。"
                ),
                _c("br"),
                _vm._v(
                  "\n      2.5 本平台有权根据业务策略，适时对商标注册服务的功能进行增加、删减、更新、调整，或取消本服务类型，具体以您使用服务当时税智汇相关页面的展示为准。若您对税智汇增加、删减、调整等的内容有异议的，应及时以书面形式告知税智汇，并停止使用税智汇商标服务；否则，将被视为您认可前述内容。"
                ),
                _c("br"),
                _vm._v(
                  "\n      2.6 商标注册成功后，甲方如您需进行平台备案（如亚马逊），税智汇会须配合在您甲方提供平台备案（如亚马逊）的邮件截图后提供给甲方您备案验证码。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("（二）外观专利服务")]),
                _vm._v(
                  "\n      2.7\n      税智汇外观设计专利注册服务，是指税智汇向您提供的一项国际外观设计专利注册申请服务，包括在线提交外观设计专利注册申请、向外观设计专利局递交、跟踪及完成外观设计专利注册全流程的平台系统及相应的“[外观专利]”系统技术服务和支持。"
                ),
                _c("br"),
                _vm._v(
                  "\n      2.8\n      您理解并同意，您通过税智汇外观设计专利服务提交的外观设计专利注册是否成功取决于外观设计专利产品本身及申请时间等因素，并最终由目的国外观设计专利局依法审查后决定。税智汇不会以任何明示或者暗示的方式担保您提交的外观设计专利注册申请能够成功，且对您的外观设计专利注册是否成功不承担法律有明确规定之外的责任。如果您要求百分之百的成功率或其他任何效果，税智汇无法做出承诺，因此请您慎重考虑是否继续使用本服务。"
                ),
                _c("br"),
                _vm._v(
                  "\n      2.9\n      税智汇有权对您提交的拟申请外观设计专利进行初步审核，如果认为申请外观设计专利的产品本身或外观设计专利申请行为不合法或不符合外观设计专利注册申请约定，税智汇有权随时终止本次外观设计专利申请服务。"
                ),
                _c("br"),
                _vm._v(
                  "\n      2.10\n      外观设计专利注册为单次服务，如您在外观设计专利审查过程中需要提起不予补正答复、注册复审、驳回复审、缴纳授权等，或需要对已申请注册的外观设计专利改变外观设计的，您均应另行购买相应的税智汇服务。"
                ),
                _c("br"),
                _vm._v(
                  "\n      2.11\n      税智汇有权根据业务策略，适时对外观设计专利注册服务的功能进行增加、删减、更新、调整，或取消本服务类型，具体以您使用服务当时税智汇相关页面的展示为准。若您对税智汇增加、删减、调整等的内容有异议的，应及时以书面形式告知税智汇，并停止使用税智汇外观设计专利服务；否则，将被视为您认可前述内容。"
                ),
                _c("br"),
                _vm._v(
                  "\n      2.12您购买的商标和/或外观设计专利服务期限原则上为自付款之日起算一年，或至以下任何一项完成时止，两者取到期较早者，该期限与软件服务期限保持一致："
                ),
                _c("br"),
                _vm._v(
                  "\n\n      1）目的国知识产权局更新了商标或专利注册号，注册成功，甲方收到乙方发送的电子证书或纸质证书。"
                ),
                _c("br"),
                _vm._v(
                  "\n      2）申请目的国的知识产权局对该商标或专利下了最终无效通知。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3）甲方书面放弃该商标或专利申请、未在申请目的国的知识产权局规定答复期限内做出回应，导致超出申请时效的。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("三、服务使用规范")]),
                _vm._v("\n      3.1 您理解并保证："),
                _c("br"),
                _vm._v(
                  "\n      3.1.1 您应对使用本服务过程中所提供的信息和材料的真实性和准确性负责；如因您故意或过失导致的信息错误，税智汇有权暂停直至终止服务，由您自行承担全部责任及后果，税智汇保留追究您法律责任的权利。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.1.2 您应向税智汇提供完整、准确、可靠的联系方式（包括但不限于手机号码、电子邮件、联系地址或其他可供联系的详细信息），如服务过程中您的联系方式发生变化，您应及时在变更后两个工作日内通知税智汇，以免影响本服务过程中信息和文件的传达。如因联系方式不准确造成的任何结果，均由您自行承担。"
                ),
                _c("br"),
                _vm._v("\n      3.2 您理解并保证："),
                _c("br"),
                _vm._v(
                  "\n      3.2.1 您应积极配合税智汇为您提供本服务的相关事宜，您同意按照税智汇提示的时间和要求，及时准确地提供、确认信息及材料并支付款项，如因您提供的信息或材料不及时、不准确，或未按照确认页面的价格按时支付款项，您需自行承担责任及后果（包括但不限于办理时间延期、申请被驳回等），税智汇有权终止本服务。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.2.2 您成功支付费用，并不代表商标和/或外观设计专利申请成功。商标和/或外观设计专利最终能否成功申请取决于商标标志本身和/或外观设计专利的产品本身及申请时间等因素，并最终由知识产权局依法审查后决定。税智汇对该商标和/或外观设计专利是否申请成功，不承担法律有明确规定之外的责任。"
                ),
                _c("br"),
                _vm._v("\n      3.3 您理解并保证："),
                _c("br"),
                _vm._v(
                  "\n      3.3.1 您在使用本服务过程中的所有行为均应遵守国家法律、法规等相关规定，不违背社会公共利益或公共道德，不损害他人的合法权益，不违反本服务协议及税智汇相关规则的约定，您的商标和/或外观设计专利注册申请不是为了恶意或任何非法目的，不得故意抢注或刻意模仿他人商标和/或外观设计专利或存在其他侵犯他人知识产权的行为，不得无使用目的大量囤积商标和/或外观设计专利。如您违反前述承诺，税智汇有权随时终止本服务，您应以自己的名义独立承担所有法律责任，并确保本平台免于因此产生任何损失。如因您使用本服务的行为给本平台及税智汇造成损失的，您应承担全部赔偿责任。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.3.2 税智汇仅为您提供咨询建议，以及代为向登记机关递交您的申请材料，该行为不能被视为税智汇对您提供的材料内容的任何认同、保证或担保。您应对提供的材料内容独立承担全部责任，如材料内容不真实、不准确或存在其他不当内容，您应独立承担一切法律责任且应保证税智汇不因此被任何第三方追究责任或受到任何其他损害，如因此给税智汇带来损失，由您承担全部责任。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.4 税智汇不会审查您使用商标和/或外观设计专利申请服务的意图，您使用本服务的行为不应使税智汇陷入任何不利或纠纷之中。如因您通过本服务申请商标和/或外观设计专利服务的行为给税智汇造成损失的，您应承担相应的责任。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.5 商标和/或外观设计专利注册成功之后，您因持有或使用注册商标和/或外观设计专利而引起的任何纠纷或损失，与本平台无关。同时，您有义务保护本平台及税智汇免于受到任何因您持有或使用此商标和/或外观设计专利而引起的第三方诉讼、索赔或其他行为而造成的损害。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.6您应自行对您发布、推广的内容、产品、服务等承担全部责任。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.7当您所购买的“[商标/外观专利]”系统服务到期时，您应及时向税智汇续费，否则，税智汇有权停止提供服务。如因您没有及时续费而造成使用“[商标/外观专利]”系统服务停止，税智汇不承担责任。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.8您只能于您业务范围内使用服务，禁止出售、转售或复制、开发使用权限。以下行为被禁止：禁止对软件进行全部或部分地翻译、分解、反向编译、反汇编、反向工程或其他试图从软件导出程序源代码的行为，或在软件的基础上书写或开发衍生软件、衍生产品或其他软件；禁止复制和模仿税智汇的设计理念、界面、功能和图表；禁止未经税智汇许可基于此项服务或内容进行修改或制造派生其他产品。禁止限制、破坏或绕过软件的加密措施。禁止去除、掩盖或更改软件上有关软件著作权或商标的标志。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3.9税智汇有权对“[商标/外观专利]”系统上您发布、推广的内容进行监督，如有涉及违反法律、法规或任何第三方合法权利的内容、文字、链接等，税智汇有权立刻删除。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("四、服务费用")]),
                _vm._v(
                  "\n\n      4.1 服务费报价和申请官方规费标准请至相应页面查询（税智汇有权随时依市场行情、相关国家知识产权局官方规费调整及其他相关因素，调整服务费和申请官方规费标准，服务费自调整之次日起生效、官方规费自各国国家知识产权局规定之生效日起适用）。如官方规费上涨的，您需补齐费用，如逾期未补齐的，税智汇不对此承担责任。"
                ),
                _c("br"),
                _vm._v(
                  "\n      4.2在服务过程中，若商标局对该商标提出补证的书面文件，您需向税智汇支付每一次商标补证的服务费用，同时您需在税智汇规定的期限内提交补证资料至税智汇；若您主动提出补证，需向税智汇支付补证的服务费用。"
                ),
                _c("br"),
                _vm._v(
                  "\n      4.3 您可就已支付的服务费用，向本平台申请相应金额的发票，并承担开具发票需要的税点金额。"
                ),
                _c("br"),
                _vm._v(
                  "\n      4.4 税智汇将在官网相关页面公示有关收费标准和缴费要求，并有权根据业务需要和市场变化等原因，调整上述标准和要求；或者根据当时的市场状况及自身经营政策等因素，制定不同的服务收费标准、优惠与促销政策等。"
                ),
                _c("br"),
                _vm._v(
                  "\n      4.5 税智汇会定期或不定期推出优惠活动或政策。您理解并确认："
                ),
                _c("br"),
                _vm._v(
                  "\n      4.5.1 此类优惠活动或政策均为税智汇在正常服务价格之外的一次性特别优惠，税智汇不保证您一定可以享受该等特别优惠。"
                ),
                _c("br"),
                _vm._v(
                  "\n      4.5.2 在优惠活动或优惠政策期间新购买本服务的可享受特别优惠，此前已购买的不可返还差价。"
                ),
                _c("br"),
                _vm._v(
                  "\n      4.5.3 除非税智汇以书面形式给予明确说明，通常情况下，多种优惠不可同时叠加适用。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("五、知识产权")]),
                _vm._v(
                  "\n      5.1 在本服务协议，税智汇向您提供的任何资料、技术或技术支持、软件、服务等的知识产权均属于提供税智汇或其合法权利人所有；除税智汇或合法权利人明示同意外，您无权复制、传播、转让、许可或提供他人使用上述知识成果，否则应承担相应的责任。"
                ),
                _c("br"),
                _vm._v(
                  "\n      5.2 您应保证提交给税智汇的信息和材料、对本服务的使用以及使用本服务所产生的成果，未侵犯任何第三方的合法权益。税智汇应保证向您提供的服务不违反现行有效的法律法规。"
                ),
                _c("br"),
                _vm._v(
                  "\n      5.3 如果第三方机构或个人对您使用本服务过程中的知识产权的归属提出质疑或投诉，您和税智汇均有责任出具相关知识产权证明材料，并配合对方的相关投诉处理工作。对于因此引起的索赔、诉讼或可能向其提起诉讼，您应负责解决，承担费用和损失，以及使本平台及税智汇免责。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("六、不可抗力及责任承担")]),
                _vm._v(
                  "\n\n      6.1 因不可抗力或者其他意外事件，使得本服务履行不可能、不必要或者无意义的，遭受不可抗力、意外事件的一方不承担责任。“不可抗力、意外事件”是指不能预见、不能克服并不能避免且对一方或双方当事人造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行等以及社会事件如战争、动乱、政府行为、电信主干线路中断等。"
                ),
                _c("br"),
                _vm._v(
                  "\n      6.2 鉴于互联网的特殊性，黑客攻击、互联网连通中断或者系统故障、电信部门原因造成的连通中断等非税智汇原因给您造成的损失，除另有生效法律文书规定外，税智汇不承担责任。"
                ),
                _c("br"),
                _vm._v(
                  "\n      6.3有限责任：平台在适用法律所允许的最大范围内，不论出于何种原因，平台对您的全部责任为您使用本平台产品和服务而向平台支付的费用总额。如果平台免费向您提供了服务，则平台无义务对您承担任何赔偿责任。任何情况下，平台不对出自本协议或与本协议有关的或与平台的运行有关的任何特殊的、偶然的、惩罚性或间接的损害（包括但不限于数据损失、利润损失或营业损失）或采购替代产品承担责任，不论该等责任是基于合同、担保、侵权（包括过失）、严格责任或其他，也不论平台是否被事先告知了损失或损害发生的可能性。即使本协议约定的有限补救措施未能实现其根本目的，前述的责任限制依然适用。"
                ),
                _c("br"),
                _vm._v(
                  "\n      6.4如果平台发现、收到他人举报或投诉您违反本协议约定或违反法律法规和国家有关规定的，平台有权采取警示、冻结、终止/中止/限制使用帐号等功能、解除或终止本协议，或提出损害赔偿等措施。"
                ),
                _c("br"),
                _vm._v(
                  "\n      6.5\n      若您的行为给平台造成损失的（包括但不限于直接损失、名誉损失、第三方的罚款、索赔等），平台有权全额向您追偿，如您在平台中有保证金、虚拟货币等财产或优惠券等虚拟权益的，平台有权冻结。"
                ),
                _c("br"),
                _vm._v(
                  "\n      6.6\n      本协议终止后，除法律有明确规定外，平台无义务向您或您指定的第三方披露您账户中的任何信息。本协议终止后，平台仍享有下列权利：根据法律规定，继续保存您留存于平台的的各类信息；对于您过往的违约行为，平台仍可依据本协议向您追究违约责任。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("七、服务验收")]),
                _vm._v(
                  "\n      在税智汇完成各类案件申请或法律文件准备后，您应及时对相关文件进行验收，并确认是否送件至各国/地区知识产权局。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("八、退款机制")]),
                _vm._v(
                  "\n      您知悉并确认仅符合如下条件之一，税智汇才会将您支付的相关服务费全部或部分退还给您："
                ),
                _c("br"),
                _vm._v(
                  "\n      ① 由于市场变化及各种因素的影响，税智汇无法保证您提交的申请委托服务都能提供，如您拟购买的服务发生“暂时无法提供服务”的情况，您和税智汇均有权取消订单，并全额退还已支付的案件相关费用。"
                ),
                _c("br"),
                _vm._v(
                  "\n      ②您成功购买服务后，如您在向提交资料前向税智汇提出终止或解除本合同的，税智汇有权要求您承担服务费总额20%的违约金，如您已支付部分/全部服务费，税智汇有权直接从您已支付费用中进行扣除；如您在向税智汇提交材料后提出终止或解除本合同的，税智汇有权要求您全额支付本协议项下的服务费，且不予退还您已付费用。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("九、保证条款")]),
                _vm._v(
                  "\n      您保证不以任何理由、任何方式自行寻求知识产权代理机构的任何专家为您私下提供服务，除非经税智汇书面同意。一经发现，税智汇有权注销（永久冻结）您及该专家的帐户，如给税智汇造成任何损失，税智汇有权向您索赔。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("十、保密条款")]),
                _vm._v(
                  "\n      1、本协议所称“商业秘密”包括：有关产业、商业、产品、技术、市场、业务信息与数据以及所有方法、工具、流程、专业技能等，但不包括下列事项："
                ),
                _c("br"),
                _vm._v("\n      ① 一方于提供时，已属公开或众所周知者；"),
                _c("br"),
                _vm._v(
                  "\n\n      ② 该资料自他人所取得，而该他人对资料未负有任何保密义务者；"
                ),
                _c("br"),
                _vm._v("\n      ③ 非因任一方作为或不作为而成为众所周知者；"),
                _c("br"),
                _vm._v(
                  "\n      ④ 一方于提供前，已为他方所知悉且无保密义务者。"
                ),
                _c("br"),
                _vm._v(
                  "\n      2、您同意因在知识产权申请委托中或进行其他税智汇平台活动中而知悉税智汇及其他第三方商业秘密者，应负保密责任，非经税智汇或其他第三方之书面同意，不得以任何形式揭露、提供予他人或使他人取得税智汇或其他第三方商业秘密。您并应采取必要措施，以防止商业秘密被窃或泄露。反之，税智汇亦履行相同保密义务。"
                ),
                _c("br"),
                _vm._v(
                  "\n\n      3、您必须保证，在税智汇平台上传、发布或传播的内容未侵犯其他任何第三方之合法权益，否则将承担由此带来的一切法律责任。"
                ),
                _c("br"),
                _vm._v(
                  "\n\n      4、您不得将任何内部资料、机密资料、涉及他人隐私资料或侵犯任何人的专利权、商标权、著作权、商业秘密或其他专属权利之内容加以上传、发布或传播。\n      若第三方认为您在税智汇上传、发布或传播的内容侵犯其合法权益，且向税智汇发出合理通知的，则税智汇有权移除涉嫌侵权内容。"
                ),
                _c("br"),
                _vm._v("\n      5、税智汇以下行为不受此条款的限制："),
                _c("br"),
                _vm._v(
                  "\n      ①因实现本合同目的需要向目的国政府及相关机构等机关提交相关资料；"
                ),
                _c("br"),
                _vm._v(
                  "\n      ②应政府部门等机构要求或办理业务需要，向政府部门等相关机构提交相关资料；"
                ),
                _c("br"),
                _vm._v(
                  "\n      ③因外部审计等需要而向律师事务所、会计师事务所等中介机构提供相关资料。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("十一、隐私权声明")]),
                _vm._v(
                  "\n      1、通常情况下，您无须提供您的姓名或其它个人信息即可访问本网站。为特定目的，如您需要税智汇平台为您提供商标和/或专利申请申请服务或其他服务，您须依相应页面进行注册并提供您相关信息，同时视为您已经了解并接受您信息的用途，同意税智汇为实现该特定目的使用您的信息。"
                ),
                _c("br"),
                _vm._v(
                  "\n      2、税智汇在任何时候、任何情况下都不会出售您的信息，只会在法律允许范围内使用您的信息。但当法律、政府机关依照法定程序要求税智汇披露您的信息时，税智汇将根据政府机关之要求或为公共安全之目的提供您的信息。在此情况下之任何披露，本网站均不承担任何责任。"
                ),
                _c("br"),
                _vm._v("\n      3、下列情况税智汇亦无需承担任何责任："),
                _c("br"),
                _vm._v(
                  "\n      ① 由于您将登录名和密码告知他人或与他人共享注册帐户，由此导致的任何信息泄露。"
                ),
                _c("br"),
                _vm._v(
                  "\n      ② 税智汇平台系统停机维护期间（税智汇平台会提前在网站上通知）。"
                ),
                _c("br"),
                _vm._v(
                  "\n      ③ 任何由于黑客政击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常运营之不可抗力而造成的用户信息泄露、丢失、被盗用或被篡改等。"
                ),
                _c("br"),
                _vm._v(
                  "\n      ④ 由于黑客攻击、电信部门技术调整或故障、网站升级、银行方面的问题等原因而造成的服务中断或者延迟。"
                ),
                _c("br"),
                _vm._v(
                  "\n      ⑤ 因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素，造成税智汇平台系统障碍不能提供服务的。"
                ),
                _c("br"),
                _vm._v(
                  "\n      ⑥ 由于与本网站链接的其它网站所造成之用户资料泄露及由此而导致的任何法律争议和后果。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("十二、协议终止")]),
                _vm._v(
                  "\n      1、出现以下情况时，税智汇有权直接以注销账户的方式终止本协议："
                ),
                _c("br"),
                _vm._v(
                  "\n      ① 税智汇终止向您提供服务后，您涉嫌再一次直接或间接或以他人名义注册为税智汇用户的；"
                ),
                _c("br"),
                _vm._v(
                  "\n      ② 您提供的电子邮箱、手机号码、微信号、QQ号等不存在或无法接收相关信息，且没有其他方式可以与您进行联系，或税智汇以其它联系方式通知您更改；\n      电子邮件信息，而您在税智汇通知后三个工作日内仍未更改为有效的电子邮箱的；"
                ),
                _c("br"),
                _vm._v(
                  "\n      ③ 您注册信息中的主要内容不真实或不准确或不及时或不完整；"
                ),
                _c("br"),
                _vm._v(
                  "\n      ④ 本协议变更时，您明示并通知税智汇不愿接受新的服务协议的；"
                ),
                _c("br"),
                _vm._v("\n      ⑤ 其它税智汇认为应当终止服务的情况。"),
                _c("br"),
                _vm._v(
                  "\n      2、您有权向税智汇要求注销您的账户，经税智汇审核同意的，税智汇注销（永久冻结）您的账户，届时，您与税智汇基于本协议的合同关系即终止。您的账户被注销（永久冻结）后，税智汇没有义务为您保留或向您披露您账户中的任何信息，也没有义务向您或第三方转发任何您未曾阅读或发送过的信息。"
                ),
                _c("br"),
                _vm._v(
                  "\n      3、您同意，您与税智汇的合同关系终止后，本平台仍享有下列权利："
                ),
                _c("br"),
                _vm._v(
                  "\n\n      ① 继续保存您的注册信息及您使用税智汇平台服务期间的所有信息。"
                ),
                _c("br"),
                _vm._v(
                  "\n      ② 您在使用税智汇平台服务期间存在违法行为或违反本协议和/或规则的行为的，税智汇仍可依据本协议向您主张权利。"
                ),
                _c("br"),
                _vm._v(
                  "\n      4、如果您是税智汇平台的非付费用户，且连续十二个月没有登陆本网站，本网站有权注销您的帐号。"
                ),
                _c("br"),
                _vm._v(" "),
                _c("h3", [_vm._v("十三、法律适用、管辖及其他")]),
                _vm._v(
                  "\n      1、本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国大陆地区法律（不包括港澳台法律），如无相关法律规定的，则应参照通用国际商业惯例和/或行业惯例。"
                ),
                _c("br"),
                _vm._v(
                  "\n      2、因本协议产生之争议，本平台会与您沟通并处理。一旦产生之争议无法解决，任何一方均可向税智汇所在地人民法院提起诉讼。"
                ),
                _c("br")
              ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "Button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.close(false)
                    }
                  }
                },
                [_vm._v("知道了")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3dad68fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dad68fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./xcloud-client-components-web/sureOrder/components/userAgreement40.vue
// module id = null
// module chunks = 